import { render } from "./SingleForm.vue?vue&type=template&id=2acfd459"
import script from "./SingleForm.vue?vue&type=script&lang=js"
export * from "./SingleForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/vokaladezful-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__